/**
 * Sizes a board's canvas to the element it sits in. Both game screens call
 * this from a `ResizeObserver`; the renderer itself returns without touching
 * the canvas when the cell size is unchanged (`docs/KNOWN-BUGS.md` item 4),
 * so calling it often is safe.
 */
import type { Canvas2DRenderer } from '../render/canvas2d-renderer.js';

export function fitToStage(
  stage: HTMLElement,
  renderer: Canvas2DRenderer,
  board: { readonly width: number; readonly visibleRows: number },
): void {
  const rect = stage.getBoundingClientRect();
  renderer.resize({
    containerWidth: rect.width,
    containerHeight: rect.height,
    devicePixelRatio: window.devicePixelRatio || 1,
    cols: board.width,
    rows: board.visibleRows,
  });
}
